<template>
    <div>
        <section>
            <div class="container">
                <div class="text-title" v-if="!showOlderNewsTitle">News Releases</div>
                <div class="text-title" v-else>Older News Releases</div>
                <div v-for="article in getPageData" :key="article.id">
                    <div class="q-my-md">
                        <div class="text-grey-7">{{ article.dateCreated | date }}</div>
                        <router-link :to="`/news/article/${article.id}`"><div v-html="article.title" class="text-h6 q-mb-sm" /></router-link>
                        <div v-html="article.description" />
                        <div><router-link :to="`/news/article/${article.id}`">Read More</router-link></div>
                    </div>
                    <q-separator class="q-my-md" />
                </div>
                <div class="row" :class="{'justify-center' : screenSize.lt.md}">
                    <q-pagination v-model="page"
                                  class="col-9 q-my-md"
                                  :max="totalPages"
                                  :max-pages="6"
                                  boundary-numbers
                                  direction-links />
                    <div class="col-3 q-my-md text-right">
                        <q-btn color="primary" :label="showOlderNews ? 'View Current News Articles' : 'View Older News Articles'" @click="showOlderNews = !showOlderNews" />
                    </div>
                </div>
            </div>
            <q-inner-loading :showing="getArticlesPending">
                <div>
                    <q-spinner color="primary"
                               :thickness="2"
                               size="3em" />
                </div>
            </q-inner-loading>
        </section>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        name: 'news',
        data() {
            return {
                articles: [],
                page: 1,
                articlesPerPage: 11,
                oneYearAgo: new Date(),
                showOlderNews: false,
                showOlderNewsTitle: false,
            }
        },

        methods: {
            getArticles() {
                this.$store.dispatch('getArticles').then(() => {
                    this.articles = this.getArticlesData;

                    if (this.showOlderNews) {
                        this.articles = this.articles.filter(article => new Date(article.dateCreated) <= this.oneYearAgo);
                        this.showOlderNewsTitle = true;
                    } else {
                        this.articles = this.articles.filter(article => new Date(article.dateCreated) > this.oneYearAgo);
                        this.showOlderNewsTitle = false;
                    }
                });
            },
        },
        computed: {
            ...mapState([
                'getArticlesData',
                'getArticlesPending'
            ]),
            getPageData() {
                return this.articles.slice((this.page - 1) * this.articlesPerPage, (this.page - 1) * this.articlesPerPage + this.articlesPerPage);;
            },
            totalPages() {
                return Math.ceil(this.articles.length / this.articlesPerPage)
            },
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.oneYearAgo.setFullYear(this.oneYearAgo.getFullYear() - 1);
            this.getArticles();
        },
        watch: {
            showOlderNews(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.getArticles();
                }
            }
        },
    }
</script>
